export default class {
  constructor($el, increment) {
    this.$ = $el;
    this.increment = increment;
    this.postLimit = $el.data('postlimit');
    this.$postGrid = $el.prev('.posts-grid');
    this.rows = (this.postLimit / this.increment) - 1;
    this.clicks = 0;
    if (this.$postGrid.length) {
      this.initPosts();
    }
  }
  initPosts() {
    let $postItems = this.$postGrid.find(".-post");
     if($postItems.length > this.increment){
       this.$.on('click', (ev)=>{
        ev.preventDefault();
        this.clicks++;
        let limit  = this.increment * (this.clicks + 1);
        console.log("clicked", this.clicks, this.rows, "limit", limit);
         $postItems.each((index, post)=>{
          if(index < limit){
            $(post).removeClass("hidden");
          }
        });
        if(this.clicks === this.rows){
          this.$.hide();
        }
      });
    } else {
      console.error("No post items for the load more was found.")
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/lib/LoadMore.js